import { render, staticRenderFns } from "./CustomersUsersGroupSelect.vue?vue&type=template&id=61203698&"
import script from "./CustomersUsersGroupSelect.vue?vue&type=script&lang=js&"
export * from "./CustomersUsersGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports